import CountryList from './List';
import CountryForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/paises',
    name: 'Cadastro Países',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'paises',
            name: 'list-country',
            component: CountryList,
            meta: {
                requiresAuth: true,
                label: 'Listar Paíss'
            }
        },
        {
            path: 'paises/novo',
            name: 'new-country',
            component: CountryForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar País'
            }
        },
        {
            path: 'paises/:id',
            name: 'edit-country',
            component: CountryForm,
            meta: {
                requiresAuth: true,
                label: 'Editar País'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/country/router.js